import { getBlockingSubscription } from '@griply/utils';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useUser } from 'shared/hooks/use-user';

export const useBlockingSubscription = () => {
  const user = useUser();
  const today = useToday();

  return useMemo(() => getBlockingSubscription(user, today), [user, today]);
};
